export default __webpack_public_path__ + "static/media/14.5c04742f.jpg";